// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"N5-z","colorTextValue":"O5-z","swatches":"P5-z","collapseLink":"Q5-z","isCollapsed":"R5-z","dropdown":"S5-z","disabled":"T5-z"};